import { formatDollarAmountWithCents } from '../../../../utils/number-formatting';
// WHY: the `text` arm goes when SALES_TAX merges — every summary amount then shows its cents.
export const summaryAmountText = (amount, alwaysShowCents)=>alwaysShowCents && amount.money != null ? formatDollarAmountWithCents(amount.money) : amount.text;
export function summaryCardRows(summaryRows) {
    let { alwaysShowCents } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        alwaysShowCents: false
    };
    return summaryRows.map((summary)=>({
            id: summary.id,
            label: summary.label.text,
            caption: summary.label.caption,
            value: summaryAmountText(summary.amount, alwaysShowCents),
            weight: summary.weight,
            entering: summary.entering === true
        }));
}
